module.exports = __webpack_public_path__ + "img/bg.fa6a95a7.png";